export default {
  meetingTitle: "{extensionName}'s Meeting",
} as const;
